import './style.css';

interface SkeletonProps {
    variant?: 'text' | 'circular' | 'rectangular' | 'rounded';
    width?: number | string;
    height?: number | string;
    className?: string;
    style?: React.CSSProperties;
}

export const Skeleton = ({
    variant = 'text',
    width = '100%',
    height = '1em',
    className = '',
    style,
}: SkeletonProps) => {
    const skeletonClasses = `skeleton skeleton-${variant} ${className}`;

    return (
        <div
            className={skeletonClasses}
            style={{
                width,
                height,
                ...style,
            }}
        />
    );
};